
import { Component, Vue } from 'vue-property-decorator'
import axios from 'axios'
import Project from '@/types/project'
import { can } from '@/globalFunctions'

@Component({
  methods: { can },
  components: {}
})

export default class ProjectReportsTab extends Vue {
  settings = {
    routeNames: { list: 'projects', show: 'projectShow', edit: 'projectEdit' },
    routeParamKey: 'projectId',
    functionNames: { setCurrent: 'setCurrentProject', save: 'saveProject' },
    getterNames: { current: 'currentProject', loading: 'loadingProject', errors: 'projectErrors' }
  }

  loading = { energy: false, hotWater: false }
  utilityCompanies = { energy: [], hotWater: [] }

  mounted (): void {
    this.getEnergyUtilityCompanies()
    this.getHotWaterUtilityCompanies()
  }

  getEnergyUtilityCompanies () : void {
    this.loading.energy = true
    axios.get(process.env.VUE_APP_API_URL + '/utilityCompanies?filter[type]=energy&sort=name').then((r) => {
      this.utilityCompanies.energy = r.data.data
    }).finally(() => {
      this.loading.energy = false
    })
  }

  getHotWaterUtilityCompanies () : void {
    this.loading.energy = true
    axios.get(process.env.VUE_APP_API_URL + '/utilityCompanies?filter[type]=hotWater&sort=name').then((r) => {
      this.utilityCompanies.energy = r.data.data
    }).finally(() => {
      this.loading.energy = false
    })
  }

  energyUtilityCompanyChanged (value:number|null|undefined): void {
    this.currentItem.energy_utility_company_id = value === undefined ? null : value

    if (this.currentItem.energy_utility_company_id === null) {
      this.currentItem.energy_auto_cancellation = false
    }
  }

  hotWaterUtilityCompanyChanged (value:number|null): void {
    this.currentItem.hot_water_utility_company_id = value === undefined ? null : value

    if (this.currentItem.hot_water_utility_company_id === null) {
      this.currentItem.hot_water_auto_cancellation = false
    }
  }

  get currentItem () : Project {
    return this.$store.getters[this.settings.getterNames.current]
  }
}
